// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"2fd11629","143":"fb8621e9","247":"d45dd550","273":"a70b03f6","609":"e32dbf22","661":"90478b48","954":"6e39d8cc","982":"2a467978"}[chunkId] + ".chunk.css";
};